import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import './NotFound.less';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { HomeOutlined } from '@ant-design/icons';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found">
      <Result
        status="404"
        title="404"
        subTitle="Page you are trying to access does not exist."
        extra={[
          <Button
            key="back"
            onClick={() => navigate(-1)}
            icon={<ArrowLeftOutlined />}
          >
            Go back to previous page
          </Button>,
          <Button
            type="primary"
            key="home"
            onClick={() => navigate('/')}
            icon={<HomeOutlined />}
          >
            Back to home page
          </Button>,
        ]}
      />
    </div>
  );
};

export default NotFound;
